import * as React from 'react'
import { NotificationCardConnected } from './NotificationCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const NotificationCardExamples = () => {
  return (
    <div className="NotificationCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <NotificationCardConnected notificationIndex={0} notificationGroup="messages" />
      </Provider>
    </div>
  )
}
